/// <amd-module name="SuiteCommerce.GiftCertificate.Common.FeedbackMessageManager"/>
define("SuiteCommerce.GiftCertificate.Common.FeedbackMessageManager", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FeedbackMessageManager = exports.FeedbackMessageType = exports.RemoveFeedbackMessageEvent = exports.AddFeedbackMessageEvent = void 0;
    exports.AddFeedbackMessageEvent = 'FeedbackMessageEvent';
    exports.RemoveFeedbackMessageEvent = 'RemoveFeedbackMessageEvent';
    var FeedbackMessageType;
    (function (FeedbackMessageType) {
        FeedbackMessageType["ERROR"] = "error";
        FeedbackMessageType["WARNING"] = "warning";
        FeedbackMessageType["INFO"] = "info";
        FeedbackMessageType["SUCCESS"] = "success";
    })(FeedbackMessageType || (exports.FeedbackMessageType = FeedbackMessageType = {}));
    var FeedbackMessageManager = /** @class */ (function () {
        function FeedbackMessageManager() {
        }
        FeedbackMessageManager.triggerMessageEvent = function (eventBuilder) {
            eventBuilder.context.trigger(exports.AddFeedbackMessageEvent, {
                message: eventBuilder.message,
                type: eventBuilder.type,
            });
        };
        FeedbackMessageManager.triggerRemoveMessageEvent = function (context) {
            context.trigger(exports.RemoveFeedbackMessageEvent, undefined);
        };
        return FeedbackMessageManager;
    }());
    exports.FeedbackMessageManager = FeedbackMessageManager;
});
